"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LicenseRegistration = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _auth = require("../../redux/modules/auth");

var _loginValidator = require("../Login/loginValidator");

var _loginValidator2 = _interopRequireDefault(_loginValidator);

var _license = require("../../redux/modules/license");

var _reduxForm = require("redux-form");

var _licenseRegistrationValidation = require("./licenseRegistrationValidation");

var _licenseRegistrationValidation2 = _interopRequireDefault(_licenseRegistrationValidation);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _LicenseRegistrationForm = require("../../components/registration/LicenseRegistrationForm");

var _LicenseRegistrationForm2 = _interopRequireDefault(_LicenseRegistrationForm);

var _LicenseLoginForm = require("../../components/registration/LicenseLoginForm");

var _LicenseLoginForm2 = _interopRequireDefault(_LicenseLoginForm);

var _reactRouterRedux = require("react-router-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LicenseRegistration = exports.LicenseRegistration = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LicenseRegistration, _Component);

  function LicenseRegistration(props) {
    (0, _classCallCheck3.default)(this, LicenseRegistration);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LicenseRegistration.__proto__ || (0, _getPrototypeOf2.default)(LicenseRegistration)).call(this, props));

    _this.submit_pois = function (values) {
      if (_this.props.emailInUse) {
        _this.props.login(values);
      } else {
        _this.props.register(values);
      }
    };

    _this.state = {
      hasDriverLicenseAvailable: false,
      emailInUse: true
    };
    return _this;
  }

  (0, _createClass3.default)(LicenseRegistration, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {

      if (this.props.auth.registrationSuccess && !this.props.auth.user) {
        this.props.pushRoute("/autologin");
      }

      if (this.props.license.invitation) {
        var invitation = this.props.license.invitation;
        if (this.state.hasDriverLicenseAvailable == false) {
          this.setState({ hasDriverLicenseAvailable: true });
          // email_in_use
          this.props.dispatch((0, _reduxForm.change)("register", "email", invitation.receiver_email));
          this.setState({ emailInUse: this.props.license.invitation.email_in_use });
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {

      if (this.props.auth.user) {
        this.props.pushRoute("/");
      }
      var invitationToken = this.props.params.invitationToken;

      if (invitationToken) {
        this.props.getInvitationByToken(invitationToken);
        this.props.dispatch((0, _reduxForm.change)("register", "invitation_token", invitationToken));
      }

      if (this.props.auth.registrationSuccess && !this.props.auth.user) {
        return _react2.default.createElement(
          "div",
          { className: "container" },
          _react2.default.createElement(_reactHelmet2.default, { title: "Rekister\xF6idy step 2" }),
          "here we go"
        );
      }
    }
  }, {
    key: "setEmailInUse",
    value: function setEmailInUse(isInUse) {
      this.setState({ emailInUse: isInUse });
      // this.props.pushRoute('/autologin');
    }
  }, {
    key: "renderLoginForm",
    value: function renderLoginForm() {
      var invitationToken = this.props.params.invitationToken;


      return _react2.default.createElement(_LicenseLoginForm2.default, {
        invitation: this.props.license.invitation,
        fields: this.props.fields,
        handleSubmit: this.props.handleSubmit,
        onSubmit: this.submit,
        auth: this.props.auth
      });
    }
  }, {
    key: "renderRegistrationForm",
    value: function renderRegistrationForm() {
      var invitationToken = this.props.params.invitationToken;


      return _react2.default.createElement(_LicenseRegistrationForm2.default, {
        invitationToken: invitationToken,
        invitation: this.props.license.invitation,
        hasDriverLicenseAvailable: this.state.hasDriverLicenseAvailable,
        fields: this.props.fields,
        login: this.props.login,
        emailInUse: this.state.emailInUse,
        handleSubmit: this.props.handleSubmit,
        setEmailInUse: this.setEmailInUse.bind(this),
        register: this.props.register,
        auth: this.props.auth
      });
    }
  }, {
    key: "render",
    value: function render() {

      if (this.state.hasDriverLicenseAvailable && this.props.license.invitation && !this.props.license.invitation.has_accepted) {

        return _react2.default.createElement(
          "div",
          { className: "container" },
          !this.props.emailInUse && _react2.default.createElement(_reactHelmet2.default, { title: "Rekister\xF6idy kuljettajaksi" }),
          !this.props.emailInUse && _react2.default.createElement(_reactHelmet2.default, { title: "Kirjaudu kuljettajaksi" }),
          this.renderRegistrationForm()
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Rekister\xF6idy" }),
        "EI lisenssej\xE4 saatavilla, ota yhteytt\xE4 lisenssin my\xF6nt\xE4j\xE4\xE4n."
      );
    }
  }]);
  return LicenseRegistration;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  register: _react.PropTypes.func.isRequired,
  resetRegister: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired,
  login: _react.PropTypes.func.isRequired,
  license: _react.PropTypes.object.isRequired,
  params: _react.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    license: state.license
  };
}, { login: _auth.login,
  register: _auth.register,
  resetRegister: _auth.resetRegister,
  getInvitationByToken: _license.getInvitationByToken,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "register",
  initialValues: {

    profile: "DRIVERPROFILE"
  },
  fields: ["profile", "email", "first_name", "last_name", "phone", "password", "password2", "send_transfer_requests", "tos_accepted", "address", "postal_code", "postal_area", "business_id", "company_name", "company_address", "company_postal_code", "company_postal_area", "order_reference", "invitation_token"],
  validate: _licenseRegistrationValidation2.default
})(LicenseRegistration));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Registration/LicenseRegistration.js
 ** module id = 1239
 ** module chunks = 0
 **/